import React from "react";
import { ArrowUpRight } from "lucide-react";
import { capabilities } from "../mock";

export default function Capabilities() {
  return (
    <section className="glow-violet relative overflow-hidden bg-transparent py-24 md:py-32">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="reveal mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="mono-label text-xs text-[var(--crtr-yellow)]">{capabilities.kicker}</span>
            <h2 className="font-display mt-4 text-6xl text-white sm:text-7xl md:text-8xl">
              {capabilities.title[0]}<br /><span className="text-[var(--crtr-yellow)]">{capabilities.title[1]}))</span>
            </h2>
          </div>
        </div>

        <div className="grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 md:grid-cols-2">
          {capabilities.items.map((c, i) => (
            <div key={i} className="group relative bg-black/25 p-8 backdrop-blur-sm transition-colors duration-300 hover:bg-black/45 md:p-10">
              <div className="flex items-start justify-between">
                <span className="mono-label text-xs text-[var(--crtr-yellow)]">{c.tag}</span>
                <ArrowUpRight className="h-5 w-5 text-white/30 transition-all group-hover:text-[var(--crtr-yellow)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
              <h3 className="font-heavy mt-6 text-2xl uppercase leading-tight text-white md:text-3xl">
                {c.head}<span className="text-[var(--crtr-yellow)]">))</span>
              </h3>
              <p className="mt-4 max-w-md text-base leading-relaxed text-white/60">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
